import React from 'react';
import { Typography } from '@mui/material';
import PortalTooltip from './PortalTooltip';
import { getTimezoneFull, getTimezoneAbbreviation } from './utils';
// Displays a time or time range in ODU's timezone with a tooltip and sr-only timezone context.
// Props:
//   startTime (required) - the time to display, or the start of a range if endTime is also provided
//   endTime (optional) - when provided, displays as a range: "startTime - endTime"
//   id, className, variant - passed through to the Typography element
//
// Examples:
//   <PortalTime startTime="6:00 PM" />
//   <PortalTime startTime="6:00 PM" endTime="6:50 PM" />
class PortalTime extends React.Component {
  //TODO: update to display edt and local time zone if different
  //Ex: "6:00 AM PST, 9:00 AM EDT"
  state = {
    isModalOpen: false,
  };

  toggleModal = () => {
    this.setState({ isModalOpen: !this.state.isModalOpen });
  };

  render() {
    const timezoneFull = getTimezoneFull();
    const timezoneAbbreviation = getTimezoneAbbreviation();
    const displayTime = this.props.endTime
      ? `${this.props.startTime} - ${this.props.endTime}`
      : this.props.startTime;
    const fullText = `${displayTime} ${timezoneFull}. All events are shown in the timezone for ODU.`;

    return (
      <>
        <PortalTooltip id={this.props.id ? `${this.props.id}_tooltip` : undefined} title={fullText}>
          <Typography
            component="a"
            variant={this.props?.variant}
            id={this.props.id}
            className={this.props?.className + ' myOdu__universityTime edt'}
            tabIndex={0}
            aria-label={fullText}
          >
            <span aria-hidden="true">
              {displayTime} {timezoneAbbreviation}
            </span>
          </Typography>
        </PortalTooltip>
      </>
    );
  }
}

export default PortalTime;
